import api from '../../helpers/axios'


export const state = {
    advisor: null,
    advisors: []
};

export const getters = {
    advisor: (state) => state.advisor,
    advisors: (state) => state.advisors,
};

export const mutations = {
    setAdvisor(state, newValue) {
        state.advisor = newValue;
    },
    setAdvisors(state, newValue) {
        state.advisor = newValue;
    },
};

export const actions = {
    createAdvisor(_, data) {
        return new Promise((resolve, reject) => {
            api.post("/advisors", data).then((res) => {
                if (res) {
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },

    updateAdvisor(_, {id, data}) {
        return new Promise((resolve, reject) => {
            api.put("/advisors/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },


    deleteAdvisor(_, id) {
        return new Promise((resolve) => {
            api.delete("/advisors/" + id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchAdvisor({commit}, {id}) {
        return new Promise((resolve, reject) => {
            api.get("/advisors/" + id).then((res) => {
                commit("setAdvisor", res.data.data);
                resolve(res.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    fetchAdvisors({commit}, {site, name, field, isActive, page, limit, listType}) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (site) {
            query += `site=${site}&`;
        }
        if (name) {
            query += `name=${name}&`;
        }
        if (field) {
            query += `field=${field}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get("/advisors" + query).then((res) => {
                commit("setAdvisors", res.data.data);
                resolve(res.data.data);
            });
        });
    },




};
